module.exports = __webpack_public_path__ + "img/材料力学9_4_4.30dc2e0a.jpg";